import DocumentComponent from "./DocumentComponent";
import { DocumentProvider } from "./DocumentComponentContext";

const DocumentComponentWrapper = (pDocument: any) => {
  const document = pDocument.doc;

  return (
    <DocumentProvider>
      <DocumentComponent
        showEditDocument={pDocument?.isEditable}
        allowDelete={document?.allowDelete}
        rejectionReason={document?.rejectionReason}
        showDownloadDocument={document?.showDownloadDocument}
        documentName={document?.documentName}
        documentStatus={document?.status}
        createdAt={document?.createdAt}
        documentID={document?.documentID}
        mediaID={document?.mediaID}
        isBackImage={pDocument?.isback}
        loanID={pDocument?.loanID}
        docID={document?.docID}
        isCoApplicant={document?.isCoApplicant}
        coApplicantKYCDetailsID={document?.coApplicantKYCDetailsID}
        pageName={pDocument?.pageName}
        loanKycDetailsID={document?.loanKycDetailsID}
        loanDetails={pDocument.loanDetails}
        isAdditionalDocs={pDocument?.isAdditionalDocs || true}
        reloadParent={() => {
          if (pDocument?.reloadParent) pDocument.reloadParent();
        }}
        documentUrl={{
          backImagePath: document?.backImagePath || document?.url || "",
          frontImagePath: document?.frontImagePath || document?.url || "",
          frontFileName:
            document?.frontFileName || document?.documentName || "",
          backFileName: document?.backFileName || document?.documentName || ""
        }}
        documentType={document?.docType || ""}
        token={pDocument?.token || ""}
        documentPassword={document?.password || ""}
        permissions={pDocument?.permissions || {}}
        isLenderDashboard={pDocument?.isLenderDashboard || false}
        isMFL_LAP={pDocument?.isMFL_LAP || false}
        tabPermissions={pDocument?.tabPermissions || {}}
        documentScreeningOptions={pDocument?.documentScreeningOptions || {}}
        mediaMetaData={pDocument?.mediaMetaData}
        displayNameInConfig={document.displayNameInConfig}
        isCompact={pDocument?.isCompact}
        allowDownload={pDocument?.allowDownload ?? true}
      />
    </DocumentProvider>
  );
};

export default DocumentComponentWrapper;
